export default __webpack_public_path__ + "static/racehorses-34c643a52ea94897bda4a30b5c4b7ea2.gif";